import { fetchWithHeaders, HTTP_METHODS, parseErrorResponse, responseData } from "@/utils/httpRequest";

export function fetchBrokerClosingReasons() {
  return fetchWithHeaders("/parameters/lender-call-log-broker-closing-reasons", {
    method: HTTP_METHODS.GET,
  })
    .then(responseData)
    .catch(parseErrorResponse);
}
